abstract class FileSystemObjectModel
{
	public id: number;
	public name: string;

	protected constructor(options: any)
	{
		this.id = options.id;
		this.name = options.name;
	}
}

export default FileSystemObjectModel;